<button class="btn btn-outline-primary" (click)="addtypeInfosRectif()">{{ step4.ajouter | translate}}</button>
<div *ngFor="let obj of rectificatif.infosRectif; let i = index">
  <button class="btn btn-outline-primary" *ngIf="i != 0" (click)="removetypeInfosRectif(i)">{{ step4.supprimer | translate }}</button>
  <app-type-infos-rectif [uid]="getUid()+'_index_'+(i+1)" [parentForm]="parentForm" [infosRectif]="obj"></app-type-infos-rectif>
</div>
